import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import FilterComp from "../../common/filter-comp.vue";
import DisplayTextData from "@/components/common/display-text-data.vue";
import ReadOnlyDialog from "@/components/common/read-only-dialog.vue";
import receiveService from "./receive-srvice";
import utility from "@/shared/utility";
import ChangeLpn from "../change-lpn-comp.vue";
import CommonDialog from "@/components/common/common-dialog.vue";
import CommonCommentDisplay from "@/components/common/common-comments-display.vue";
import LineItemsDialog from "../line-items-dialog-comp.vue";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      lpnData: {},
      mainPage: "",
      subPage: "",
      backSlash: true,
      commentsData:"",
      pageUrl: "",
      showAdd: false,
      showChangeLpn: false,
      searchLineItem: "",
      lineDialogType: "",
      labelValue: false,
      enable_add_line: false,
      detailsKey: 0,
      receiveType: "",
      detailsData: false,
      displayArrayData: [],
      showAll: false,
      resetLocation: "",
      showLineItem: false,
      lineMessage: "Add Line Items",
      message: "",
      showDialog: false,
      completeDetailsData: [],
      showComments: false,
      totalRecords: 0,
      pageCount: 0,
      commentsObj: "",
      dialogType: "",
      lpnObj: {},
      lineObj: {
        UserId: 0,
        so_key: 0,
        line_id: 0,
        show_closed: true,
        PageNumber: 1,
        DiscrepancyTag: "",
      },
      lineTypeObj: {
        bu_key: 0,
        ordertype_desc: "",
        line_key: 0,
        rma: "",
        detailsKey: "",
        receiveType: "",
      },

      detailsList: [],
      isKyndryl: false,
      detailsHeader: [
        {
          text: "Line#",
          value: "Line#",
          class: "primary customwhite--text",
        },
        {
          text: "Part#",
          value: "Part#",
          class: "primary customwhite--text",
        },
        {
          text:"Part Class",
          value:"part_class",
          class:"primary customwhite--text"
        },
        {
        },
        {
          text: "Warehouse",
          value: "Warehouse",
          class: "primary customwhite--text",
        },
        {
          text: "Location",
          value: "Location",
          class: "primary customwhite--text",
        },
        {
          text: "Grade",
          value: "Grade",
          class: "primary customwhite--text",
        },
        {
          text: "Open",
          value: "Open",
          class: "primary customwhite--text",
        },
        {
          text: "Marked For Resolution",
          value: "dsc_qty",
          class: "primary customwhite--text",
        },
        {
          text: "Actions",
          value: "actions",
          class: "primary customwhite--text",
        },
      ],
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    this.route = this.route.split("/")[0];
    this.detailsKey = atob(this.$route.path.replace("/", "")?.split("/")[2]);
    this.receiveType = this.$route.path.replace("/", "")?.split("/")[1];
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.lineTypeObj.receiveType = this.receiveType;
    if (this.receiveType === "SO" || this.receiveType === "PO") {
      this.mainPage = "Receiving";
      this.favouriteList = data.favouriteList;
      this.pageUrl = "receiving";
      this.subPage = `${this.receiveType} Receiving Details`;
    }
    
    this.commentsObj = {
      UserId: this.userId,
      type: this.receiveType,
      order_id: this.detailsKey,
      pass: 2,
    };
  },
  computed: {},

  async mounted() {
    this.lineObj.DiscrepancyTag =
      this.getDiscrepancyTagDetails()?.DiscrepancyTag;
    try {
      // Get and parse LPN details
      const lpnDetails = this.getLpnDetails();
      if (!lpnDetails) return;
      // Update component state with LPN data
      this.updateLpnState(lpnDetails);
      // Fetch order details based on type
      const detailsData = await this.fetchOrderDetails();
      this.isKyndryl = detailsData[0].isKyndryl;
      if (!detailsData?.length) return;
      // Set display data
      this.setDisplayData(detailsData[0]);
      // Add conditional fields
      this.addConditionalFields(detailsData[0]);
      // Prepare and fetch line items
      await this.fetchLineItems();
    } catch {
      // Add proper error handling here
    }
  },
  methods: {
    getLpnDetails() {
      try {
        return JSON.parse(
          EncryptUtility.localStorageDecrypt("receivelpnDetails")
        );
      } catch {
        return null;
      }
    },
    actionSetter(permission) {
      return utility.actionSetter(this.actionList, permission);
    },
    getDiscrepancyTagDetails() {
      try {
        const key = this.receiveType === "SO" ? "soSearchObj" : "poSearchObj";
        const decryptedData = EncryptUtility.localStorageDecrypt(key);
        return decryptedData ? JSON.parse(decryptedData) : {};
      } catch {
        return null;
      }
    },
    onChangeSwitch() {
      if (this.showAll) {
        this.detailsList = this.completeDetailsData;
      } else {
        this.detailsList = this.completeDetailsData.filter(
          (item) => !item.IsClosed
        );
      }
    },

    updateLpnState(lpnObj) {
      this.lpnObj = lpnObj;
      Object.assign(this, {
        showReceiveLPN: Boolean(lpnObj.lpn),
        showLpnVal: lpnObj.lpn || "",
        showReceiveStaging: Boolean(lpnObj.bin),
        showReceiveStagingVal: lpnObj.bin || "",
      });
    },

    async fetchOrderDetails() {
      const service =
        this.receiveType === "SO"
          ? receiveService.getRecevingSalesOrderDetails.bind(receiveService)
          : receiveService.getRecevingPurchaseOrderDetails.bind(receiveService);

      return await service("get", this.userId, this.detailsKey);
    },

    setDisplayData(data) {
      if (!data) return;
      this.enable_add_line=data.enable_add_line
      this.lineTypeObj.vendor_id= data.vendor_id? data.vendor_id : 0;
      this.lineTypeObj.bu_key = data.bu_key;
      this.lineTypeObj.ordertype_desc = data.ordertype_desc;
      this.lineTypeObj.rcvloc_key = data.rcvloc_key;
      this.lineTypeObj.rma = data.rma;
      this.lineTypeObj.detailsKey = this.detailsKey;
      this.showDetails = true;
      this.displayArrayData = [
        {
          label: data?.sono ? "SO Number" : "PO Number",
          value: data?.sono || data?.purno,
          valueCss: "f-16 f-bold",
        },
        { label: "Project", value: data?.project },
        { label: "Business", value: data?.business },
        { label: "RMA", value: data?.rma },
        {
          label: "Company",
          value: data?.name,
          subValue: data?.company || data?.vendor,
        },
        { label: "Order No", value: data?.ordno },
        { label: "Order Type", value: data?.order_type },
      ];
    },

    addConditionalFields(data) {
      if (data?.RITM) {
        this.displayArrayData.splice(4, 0, {
          label: "RITM",
          value: data.RITM,
        });
      }

      if (data?.request_number) {
        this.displayArrayData.splice(6, 0, {
          label: "Request Number",
          value: data.request_number,
        });
      }
    },

    async fetchLineItems() {
      try {
        // Update lineObj with the correct keys
        this.lineObj = {
          ...this.lineObj,
          UserId: this.userId,
          ...(this.receiveType === "SO"
            ? { so_key: this.detailsKey }
            : { po_key: this.detailsKey }),
        };
        // Get the appropriate service method
        const serviceMethod =
          this.receiveType === "SO"
            ? receiveService.getRecevingSalesOrderLineItems.bind(receiveService)
            : receiveService.getRecevingPurchaseOrderLineItems.bind(
                receiveService
              );
        // Call the service method with the required parameters
        const lineDetailsData = await serviceMethod(
          "post",
          this.lineObj,
          false
        );
        this.showComments = true;
        this.commentsData = {
          NotesInfo: lineDetailsData?.Result?.NotesInfo,
          CommentsInfo: lineDetailsData?.Result?.CommentsInfo,
        };
        // Check if the response has the expected structure
        if (lineDetailsData?.Result?.LineInfo) {
          this.completeDetailsData = lineDetailsData.Result.LineInfo;
          this.detailsList = this.completeDetailsData.filter(
            (item) => !item.IsClosed
          );
          if( this.detailsList.length==0){
            this.$router.go(-1);
          }
        
         
        } else {
          this.detailsList = [];
        }
      } catch (error) {
        this.detailsList = [];
        throw error;
      }
    },
    async fetchOrders(searchType, pageNum = 1) {
      this.searchType = searchType;
      let requestObj;
      if (searchType === "search") {
        requestObj = {
          UserId: this.userId,
          SearchStr: this.textSearch,
          projKey: this.lpnObj.proj_key,
          show_closed: this.includeClosed ? 1 : 0,
          PageNumber: pageNum,
        };
      } else {
        requestObj = this.receiveType === "SO" ? this.soObj : this.poObj;
        requestObj.userId = this.userId;
        requestObj.ProjKey = this.lpnObj.proj_key;
        requestObj.show_closed = this.includeClosed ? 1 : 0;
        requestObj.PageNumber = pageNum;
      }

      let serviceMethod =
        searchType === "search"
          ? this.receiveType === "SO"
            ? receiveService.postSalesOrderSearch.bind(receiveService)
            : receiveService.postPurchaseOrderSearch.bind(receiveService)
          : this.receiveType === "SO"
          ? receiveService.postSalesOrderAdvance.bind(receiveService)
          : receiveService.postPurchaseOrderAdvance.bind(receiveService);
      let response = await serviceMethod("post", requestObj, false);
      this.showTable = true;
      this.tableData = response?.Resultset || [];
      this.tableData?.forEach((element) => {
        element.order_date = utility.displayDateFormat(element.order_date);
      });
      this.totalRecords = response?.TotalRecords;
      this.pageCount = response?.TotalPages;
    },
    // Usage:
    async onClickSearch(pageNum) {
      await this.fetchOrders("search", pageNum);
    },
    async onClickFind(pageNum) {
      await this.fetchOrders("filter", pageNum);
    },
    onPageChange(pageNumber) {
      this.searchType == "filter"
        ? this.onClickFind(pageNumber)
        : this.onClickSearch(pageNumber);
    },
    onClickReceiveStagingFunction() {
      this.$router.push(`/receiving/${this.receiveType}`);
    },
    onClickLineItemDetails(item) {
      let id = this.detailsKey;
      let lineId = item.line_id;
      EncryptUtility.localStorageEncrypt(
        "receiveDetailsData",
        JSON.stringify(this.displayArrayData)
      );
      let kyndrylVal = this.isKyndryl == true ? 1 : 0;
      this.$router.push(
        `/receiving-details-line-item/${this.receiveType}/${btoa(
          id?.toString()
        )}/${btoa(lineId?.toString())}/${btoa(kyndrylVal?.toString())}`
      );
    },
    onClickReceiveLPNFunction() {
      this.showChangeLpn = true;
      this.dialogType = "LPN";
    },
    receiveQuickVerificationFunction() {
      this.showChangeLpn = true;
      this.dialogType = "Verify";
    },
    closeChangeLpnDialog(lpn) {
      if (lpn) {
        this.showLpnVal = lpn;
        this.lpnObj.lpn = lpn;
        EncryptUtility.localStorageEncrypt(
          "receivelpnDetails",
          JSON.stringify(this.lpnObj)
        );
      }
      this.showChangeLpn = false;
    },

    onClickReceiveResetFunction(value) {
      this.resetLocation = value;
      this.showDialog = true;
      this.message = `Are you sure you want to close this receipt? You will lose any unsubmitted data`;
    },
    onClickDialogOk() {
      this.showDialog = false;
      this.resetLocation == "reset"
        ? this.$router.push(`/receiving`)
        : this.$router.go(-1);
    },
    onClickDialogCancel() {
      this.showDialog = false;
    },
    onClickAddLineItem() {
      this.showLineItem = true;
      this.lineMessage = "Add Line Items";
      this.lineDialogType = "add";
    },

    onClickLineItemCancel() {
      this.showLineItem = false;     
      this.lineTypeObj.line_id = 0;
    },
    onClickEditLine(item) {
      this.showLineItem = true;
      this.lineMessage = "Edit Line Items";
      this.lineDialogType = "edit";
      this.lineTypeObj = {
        ...this.lineTypeObj,
        line_id: item.line_id,
      };
    },

    onClickLineItemOk() {
      this.showLineItem = false;
      this.lineTypeObj.line_id = 0;
      this.fetchLineItems();
    },
  },
  components: {
    breadcrumbComp,
    FilterComp,
    DisplayTextData,
    ReadOnlyDialog,
    ChangeLpn,
    CommonDialog,
    CommonCommentDisplay,
    LineItemsDialog,
  },
};
